import React, { useEffect, useState } from 'react'
import { Eye, Star, Heart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAddToFav , checkIfFav  } from '../Functions';

export default function Card_1({ video, channel }) {

    const AddToFav = useAddToFav();
    const [isFav, setIsFav] = useState(false);

    const navigate = useNavigate();


    function select() {
        console.log(video, channel)
        navigate("/video", { state: { video, channel } });
    }

    function convertToMinutes(numb) {
        const totalSeconds = Math.floor(numb * 0.0166667 * 60); // convert to seconds
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;

        // Add leading zeros
        const formattedMinutes = String(minutes).padStart(2, '0');
        const formattedSeconds = String(seconds).padStart(2, '0');

        return `${formattedMinutes}:${formattedSeconds}`;
    }


    useEffect(() => {
        if (video?.Thumbnail) {
            checkIfFav(video.ID, setIsFav);
        }
    }, [video]);


    return (
        <div className="card" data-aos="zoom-in">

            <div style={{position:'relative'}} >
                <button className='addToFav' onClick={()=>AddToFav(video , setIsFav)}>
                    <Heart color='var(--main-pink)' fill={isFav ? 'var(--main-pink)' : 'none'}  size={20} /></button>

                <img src={video.Thumbnail} className="card-img-top" alt="..."  onClick={() => select()} />
                <span className='time' style={{ position: 'absolute', bottom: '5px' , right:'5px'}}>{convertToMinutes(video.Duration)}</span>
            </div>

            <div className="card-body" >
                <h5 className="card-title text-light">{video.Title}</h5>

                <div className='card-info d-flex flex-row justify-content-between align-items-center' >
                    <p className='text-light p-0 m-0' ><Eye size={15} color='white' /> {video.PlayCount}</p>
                    <p className='text-light p-0 m-0' ><Star size={15} fill='#d4a014d6' strokeWidth={0} /> {video.avrate}</p>
                </div>
            </div>
        </div>
    )
}
